<template>
  <div>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-btn text icon color="green">
        <v-icon @click="doClause()">mdi-keyboard-backspace</v-icon>
      </v-btn>
      <v-toolbar-title class="toolbar-title-custom">Clause No: {{ this.clseNo }} - {{ this.clseTitle }}</v-toolbar-title>
    </v-toolbar>
    <v-tabs v-model="tabMenu">
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab @click="resetTab()">Permitted Clause on Business Class</v-tab>
      <v-tab v-show="busClsClseReviewTab" @click="resetTab(2)">{{ ids.tranMode !== 'New' ? 'Action' : 'New Permitted Clause' }}</v-tab>
      <v-tab-item>
        <bus-cls-clse-list
          :fetchBusClsClse="fetchBusClsClse"
          :clseNo="clseNo"
          :clseTitle="clseTitle"
          @doReview="doBusClsClseReview"
          @doNew="doBusClsClseNew"
          @doQuery="doBusClsClseQuery"
        ></bus-cls-clse-list>
      </v-tab-item>
      <v-tab-item>
        <bus-cls-clse-form :ids="ids" @resetTab="resetTab"></bus-cls-clse-form>
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import BusClsClseList from '../list/BusClsClseList'
import BusClsClseForm from '../form/BusClsClseForm'

export default {
  data() {
    return {
      tabMenu: 0,
      busClsClseReviewTab: false,
      fetchBusClsClse: false,
      ids: {
        tranMode: null,
        clseNo: null,
        busCls: null
      }
    }
  },
  methods: {
    async resetTab(tab) {
      switch (tab) {
        case 2: {
          this.tabMenu = 1
          this.busClsClseReviewTab = true
          this.fetchBusClsClse = false
          break
        }
        default: {
          this.tabMenu = 0
          this.ids.tranMode = null
          this.ids.branch = null
          this.ids.busCls = null
          this.busClsClseReviewTab = false
          this.fetchBusClsClse = true
        }
      }
    },
    doBusClsClseReview(data) {
      this.ids.tranMode = 'Review'
      this.ids.clseNo = this.clseNo
      this.ids.branch = data.branch
      this.ids.busCls = data.busCls
      this.ids.clseTitle = this.clseTitle
      this.busClsClseReviewTab = true
      this.fetchBusClsClse = false
      this.tabMenu = 1
    },
    doBusClsClseNew() {
      this.ids.tranMode = 'New'
      this.ids.clseNo = this.clseNo
      this.ids.clseTitle = this.clseTitle
      this.busClsClseReviewTab = true
      this.fetchBusClsClse = false
      this.tabMenu = 1
    },
    doBusClsClseQuery(data) {
      this.ids.tranMode = 'Query'
      this.ids.clseNo = this.clseNo
      this.ids.branch = data.branch
      this.ids.busCls = data.busCls
      this.ids.clseTitle = this.clseTitle
      this.busClsClseReviewTab = true
      this.fetchBusClsClse = false
      this.tabMenu = 1
    },
    doClause() {
      this.$router.push({ name: 'reviewClause', params: { clseNo: this.clseNo, clseTitle: this.clseTitle } })
    }
  },
  components: {
    BusClsClseList,
    BusClsClseForm
  },
  props: {
    clseNo: {
      type: String,
      default: ''
    },
    clseTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
</style>
